import {NavbarContainer} from "./../components/templates/navbar/Navbar";
import {ChartContainer} from "./../components/templates/chart/ChartContainer";
import {TechnicalAnalysisContainer} from "./../components/templates/technical_analysis/TechnicalAnalysisContainer";


const Home = () => {

    return (
        <>
            <div className="dark-bg-with-gradients">
                <NavbarContainer/>
                <div className="chart-wrapper">
                    <div id="div-chart-content" className="chart-content-wrapper">
                        <ChartContainer/>
                    </div>
                </div>
            </div>
            <div className="analysis-wrapper">
                <div className="analysis-content-wrapper">
                    <TechnicalAnalysisContainer/>
                </div>
            </div>
        </>
    )
}

export default Home;